import { render, staticRenderFns } from "./UserSetting.vue?vue&type=template&id=7a908ecb&scoped=true&"
import script from "./UserSetting.vue?vue&type=script&lang=ts&"
export * from "./UserSetting.vue?vue&type=script&lang=ts&"
import style0 from "./UserSetting.vue?vue&type=style&index=0&id=7a908ecb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a908ecb",
  null
  
)

export default component.exports